import { render, staticRenderFns } from "./index.vue?vue&type=template&id=650d4180&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EmptyEntityCardsSlider: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/EmptyEntityCardsSlider/index.vue').default,ExcursionCard: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/ExcursionCard/index.vue').default,SliderWithBullets: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/SliderWithBullets/index.vue').default,Scroller: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/Scroller/index.vue').default,Section: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/Section/index.vue').default})
